var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.82 10.9389L9.49645 8.62737C10.2163 7.7179 10.6456 6.56842 10.6456 5.33053C10.6456 2.38737 8.25888 0 5.3165 0C2.37411 0 0 2.38737 0 5.33053C0 8.27368 2.38674 10.6611 5.32912 10.6611C6.57932 10.6611 7.71586 10.2316 8.6251 9.51158L10.9361 11.8232C11.0624 11.9495 11.2139 12 11.3781 12C11.5422 12 11.6938 11.9368 11.82 11.8232C12.06 11.5705 12.06 11.1789 11.82 10.9389ZM5.32912 9.41053C3.08129 9.41053 1.23757 7.57895 1.23757 5.31789C1.23757 3.05684 3.06867 1.22526 5.32912 1.22526C7.58958 1.22526 9.40805 3.06947 9.40805 5.33053C9.40805 7.59158 7.57695 9.41053 5.32912 9.41053Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.99fb37bfffdf21559fd8936bdb17ea4d.svg";
export { ForwardRef as ReactComponent };